import { render } from "./AdminAds.vue?vue&type=template&id=2b1eaab1"
import script from "./AdminAds.vue?vue&type=script&lang=js"
export * from "./AdminAds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__